<div class="masonry-card__container">
  <mat-card class="mat-card--mobile-flat">
    <div style="line-height: 1.5rem;">
      <p style=" font-weight: 600;">{{ reward.name }}</p>
      <strong *ngIf="reward.category" class="text-primary">
       <small> {{ reward.category.name }}</small>
      </strong>
    </div>
    <mat-divider></mat-divider>
    <div class="reward-image__container">
      <img
        class="reward-image"
        style="width:100%;"
        [src]="reward.image"
      >
    </div>
    <mat-divider></mat-divider>

    <mat-card-content >
      <p  [innerHTML]="reward.description"></p>
      <div *ngIf="!!purchase" style="display: flex; flex-direction: row; justify-content: flex-end; margin-top:1rem;">

        <span>Ottenuto il: {{ purchase.created | date:'mediumDate' :undefined :'it'   }}</span>
      </div>
    </mat-card-content>

    <div *ngIf="!purchase" style="padding-top:0;">
      <div  style="display: flex; flex-direction: row; justify-content: flex-end">
        <span *ngIf="points === undefined">
          <span>Calcolo punti in corso</span>
          <span>&nbsp;&nbsp;</span>
          <i class="fas fa-circle-notch fa-spin"></i>
        </span>
        <ng-container *ngIf="points !== undefined">
          <ng-container [ngSwitch]="points.balance >= reward.points">
            <span
              class="btn btn-pollstar btn-pollstar-small btn-gradient-orange pointer"
              *ngSwitchCase="true"
              (click)="confirm_purchase(reward)"
            >
                <span>Ottieni con {{ reward.points }} Punti</span>
            </span>
            <i *ngSwitchCase="false" class="extra-point-needed__container">
              <strong class="extra-point-needed text-primary">
                <span>{{ points.balance }}</span>
                <span> / </span>
                <span>{{ reward.points }}</span>
                <span>&nbsp;</span>
                <span>Punti</span>
              </strong>
              <small>
                <span style="color:rgba(0, 0, 0, 0.54);">
                  Ti mancano {{ reward.points - points.balance }} punti
                </span>
              </small>
            </i>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </mat-card>
</div>

